export default __webpack_public_path__ + "static/media/RuinsEdgeMap.fbc4a405.jpg";